import { useEffect, useState } from "react";
import { IoCloseSharp } from "react-icons/io5";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { Badge } from "reactstrap";
import { getOrderIDColor, getStatusColor } from "../../utility";
import GeneralButton from "../button/GeneralButton";
import { FiCopy } from "react-icons/fi";
import toast from "react-hot-toast";
const SalesOrderLinks = ({
  togglepurchaseOrderModal,
  toggleShippingModal,
  togglecreditCardModal,
  togglePackageSlipModal,
  state,
  handleSubmitOrder,
  loader,
  fromPDF,
  toggle,
  setReturnVendor,
  toggleInvoiceModal,
  handleCapturePayment,
  captureLoading,
  loading,
}) => {
  const history = useHistory();
  const location = useLocation();
  const [path, setPath] = useState("");
  useEffect(() => {
    let res = location?.pathname?.split("/");
    setPath(res);
  }, [location]);
  return (
    <>
      <div className="modern-order-header mb-2 py-2 px-1">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-3">
            <h4 className="mb-0 fw-bold text-dark d-flex align-items-center gap-2" style={{ letterSpacing: "-0.5px" }}>
              {path?.includes?.("return-order-details")
                ? `Return Order # ${state?.id}`
                : `Order # ${state?.id}`}
              <FiCopy
                size={16}
                className="pointer text-muted custom-copy-icon"
                title="Click to copy"
                onClick={() => {
                  navigator.clipboard.writeText(state?.id);
                  toast.success("Order number copied!");
                }}
              />
            </h4>
            <div className="d-flex gap-2">
              <span style={{
                backgroundColor: `${getStatusColor(state?.status)}`,
                color: getOrderIDColor(state?.status),
                padding: "4px 12px",
                borderRadius: "20px",
                fontSize: "12px",
                fontWeight: "700",
                border: `1px solid ${getOrderIDColor(state?.status)}30`,
                textTransform: "uppercase"
              }}>
                {state?.status}
              </span>
              {state?.paymentStatus && (
                <span style={{
                  backgroundColor: state?.paymentStatus === "Paid" ? "rgba(39, 174, 96, 0.1)" : "rgba(0, 80, 157, 0.1)",
                  color: state?.paymentStatus === "Paid" ? "#27AE60" : "var(--primary-blue)",
                  padding: "4px 12px",
                  borderRadius: "20px",
                  fontSize: "12px",
                  fontWeight: "700",
                  border: `1px solid ${state?.paymentStatus === "Paid" ? "#27AE6030" : "var(--primary-blue)30"}`,
                  textTransform: "uppercase"
                }}>
                  {state?.paymentStatus}
                </span>
              )}
            </div>
          </div>

          <div className="d-flex align-items-center gap-4">
            <ul className="list-unstyled d-flex align-items-center gap-3 mb-0">
              {!path?.includes?.("return-order-details") && (
                <li className="order-nav-link" onClick={() => { setReturnVendor(true); toggle(); }}>
                  Return
                </li>
              )}
              <li className="order-nav-link" onClick={togglePackageSlipModal}>Packing Slip</li>
              <li className="order-nav-link" onClick={toggleInvoiceModal}>Invoice</li>
              <li className="order-nav-link" onClick={() => { setReturnVendor(false); togglepurchaseOrderModal(); }}>
                Purchase Order
              </li>
              <li className="order-nav-link" onClick={toggleShippingModal}>Ship</li>
              <li className="order-nav-link" onClick={togglecreditCardModal}>Card</li>
            </ul>

            <div className="d-flex align-items-center gap-2 border-start ps-4 ml-2">
              {state?.paymentStatus === "Authorized" && (
                <GeneralButton
                  title={"Capture Payment"}
                  width={"180px"}
                  height={"42px"}
                  className={"red-button rounded-8 shadow-sm"}
                  handleClick={handleCapturePayment}
                  loading={captureLoading}
                  disabled={captureLoading}
                />
              )}
              <GeneralButton
                title={"Update"}
                width={"120px"}
                height={"42px"}
                className={"blue-button rounded-8 shadow-sm"}
                handleClick={handleSubmitOrder}
                loading={loader}
                disabled={loader}
              />
              <button
                className="btn btn-light rounded-circle p-1 ms-2 hover-glow"
                onClick={() => {
                  if (location?.state?.fromTracking) {
                    history.goBack();
                  } else if (state?.fromRO && path?.includes?.("sale-order-details")) {
                    history.goBack();
                  } else if (fromPDF || path?.includes?.("return-order-details") || path?.includes?.("sale-order-details")) {
                    history.push("/admin/sale-orders");
                  } else {
                    history.goBack();
                  }
                }}
              >
                <IoCloseSharp size={24} className="text-muted" />
              </button>
            </div>
          </div>
        </div>

        <style>{`
        .order-nav-link {
          cursor: pointer;
          font-size: 13.5px;
          font-weight: 600;
          color: #000;
          padding: 6px 10px;
          border-radius: 6px;
          transition: all 0.2s ease;
        }
        .order-nav-link:hover {
          color: var(--primary-blue);
          background: rgba(0, 80, 157, 0.05);
        }
      
      `}</style>
      </div>
    </>
  );
};
export default SalesOrderLinks;
